export default "__VITE_ASSET__k7fr5l3d__"